<template>
    <div class="px-2" v-loading="isLoading">
        <div v-if="!isLoading && !hasData" class="text-center py-10 my-10">
            <i class="el-icon-document-delete" style="font-size: 40px; color: #909399; margin-bottom: 10px;"></i>
            <p style="font-size: 16px; color: #909399; font-weight: 500;">Giảng viên chưa nhận xét</p>
        </div>
        <div v-if="!isLoading && hasData">
            <span style="font-style: italic;">( Giai đoạn từ Buổi {{ reviews?.start_lesson }} -> Buổi {{ reviews?.lesson }} (từ {{ reviews?.start_date }} đến {{ reviews?.end_date }}) )</span>
            <div class="mt-4 mb-8">
                <p style="font-weight: 700; font-size: 20px">Kết quả học tập</p>
                <div class="row">
                    <div class="col-6">
                        <div class="d-flex justify-content-between border rounded p-2">
                            <p class="mb-0" style="font-weight: 400; font-size: 16px;">Chuyên cần</p>
                            <p class="mb-0"><span style="font-weight: 700; font-size: 16px;">{{ reviews?.metrics?.attendance?.done ?? 0 }}/{{ reviews?.metrics?.attendance?.total ?? 0 }}</span> buổi</p>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex justify-content-between border rounded p-2">
                            <p class="mb-0" style="font-weight: 400; font-size: 16px;">Làm bài tập</p>
                            <p class="mb-0"><span style="font-weight: 700; font-size: 16px;">{{ reviews?.metrics?.homework?.done ?? 0 }}/{{ reviews?.metrics?.homework?.total ?? 0 }}</span> bài</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-4 mb-8">
                <p class="mb-1" style="font-weight: 700; font-size: 20px">Tích lũy năng lực từ đầu khóa</p>
                <span style="font-style: italic;">Kết quả được cập nhật tính tới thời điểm {{ reviews?.snapshot_at }}</span>
                
                <div class="row mt-4">
                    <div class="col-6 mb-4" v-for="skill in skillList" :key="skill.key">
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="mb-1" style="font-weight: 700;">{{ skill.label }} : {{ skills[skill.key] }}%</p>
                            <div style="padding-right: 50px; font-weight: 700;" class="d-flex" v-if="reviews?.metrics?.skills_delta?.[skill.key]">
                                <p class="mb-0" :class="reviews?.metrics?.skills_delta?.[skill.key]?.type == 'decrease' ? 'text-danger' : 'text-success'">
                                    {{ reviews?.metrics?.skills_delta?.[skill.key]?.value ?? 0 }}%
                                </p>
                                <i :class="reviews?.metrics?.skills_delta?.[skill.key]?.type == 'decrease' ? 'el-icon-bottom text-danger' : 'el-icon-top text-success'" style="font-weight: 700;"></i>
                            </div>
                        </div>
                        <el-progress 
                            :show-text="false"
                            :percentage="skills[skill.key]" 
                            :status="reviews?.metrics?.skills_delta?.[skill.key]?.type == 'decrease' ? 'exception' : reviews?.metrics?.skills_delta?.[skill.key]?.type == 'increase' ? 'success' : ''">
                        </el-progress>
                    </div>
                </div>
            </div>
            <div class="my-4 mb-8 border rounded-lg p-2" style="background-color: #FFD600;">
                <div class="d-flex justify-content-between p-2">
                    <p class="mb-1" style="font-weight: 700; font-size: 20px">Giảng viên đánh giá động lực</p>
                    <el-tag type="info">{{ getLearningAttitude(comments?.learning_attitude ?? 1) }}</el-tag>
                </div>
                <div v-if="comments?.attitude_comment"  class="p-2" style="font-style: italic; word-break: normal;" v-html="comments?.attitude_comment">
                </div>
                <p v-else class="p-2" style="font-style: italic; word-break: normal;">
                   "{{ comments?.automatic_comments?.join('. ') }}"
                </p>
                <div class="p-2" v-if="comments?.qlhv_support.length">
                    <p class="mb-1" style="font-weight: 700; font-size: 20px">Đề xuất QLHV hỗ trợ</p>
                    <div class ="d-flex justify-content-start ">
                        <el-tag type="info" class ="mr-2" v-for="item in comments?.qlhv_support">{{ getSupportLabel(item) }}</el-tag>
                    </div>
                </div>
            </div>
            <div class="my-4 mb-8">
                <p style="font-weight: 700; font-size: 20px">Giảng viên đánh giá năng lực</p>
                <div class="row mt-4">
                    <div class="col-6 mb-3" v-for="skill in skillList" :key="'ability-' + skill.key">
                        <div class="d-flex justify-content-between border-bottom pb-1">
                            <p class="mb-0" style="font-weight: 600;">{{ skill.label }}</p>
                            <p class="mb-0 mr-2" style="font-weight: 700;">
                                {{ getLabelLearningAttitude(comments?.learning_ability?.[skill.key] ?? 4) }} 
                                <i :class="getIconLearningAttitude(comments?.learning_ability?.[skill.key] ?? 4)"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-4 mb-8">
                <p style="font-weight: 700; font-size: 20px">Phương án xử lý</p>
                <div class="d-flex justify-content-start">
                    <el-tag type="info" class="mr-4" v-for="(item, index) in (comments?.resolution_plan ?? [])" :key="index">
                        {{ getPlan(item?.type) }}
                    </el-tag>
                </div>
            </div>

            <div class="my-4 mb-8">
                <p style="font-weight: 700; font-size: 20px">Dự đoán khả năng đạt đầu ra</p>
                <el-tag effect="dark" :type="forecast.type" class="mr-4">{{ forecast.label }}</el-tag>
            </div>
        </div>
    </div>
</template>

<script>
import { STAGE_REVIEW_DETAIL } from '../../../../core/services/store/customer/customer-crm.module';

const ATTITUDE_MAP = {
    1: 'Rất tích cực',
    2: 'Chủ động',
    3: 'Ổn định',
    4: 'Thụ động',
    5: 'Rất tiêu cực'
};

const SUPPORT_MAP = {
    'homework': 'Đốc thúc làm bài tập về nhà',
    'attendance': 'Đốc thúc chuyên cần',
    'learning_motivation': 'Đốc thúc động lực học',
};

const ATTITUDE_LABEL_MAP = {
    1: 'Tốt',
    2: 'Khá',
    3: 'Trung bình',
    4: 'Yếu'
};

const ATTITUDE_ICON_MAP = {
    1: 'el-icon-success text-success',
    2: 'el-icon-star-on text-warning',
    3: 'el-icon-warning-outline text-info',
    4: 'el-icon-warning text-danger'
};

const FORECAST_MAP = {
    1: { label: 'Khả năng đạt đầu ra cao', type: 'success' },
    2: { label: 'Chưa rõ ràng', type: 'warning' },
    3: { label: 'Nguy cơ fail khóa cao', type: 'danger' }
};

export default {
    name: 'ModalDetailRegiment',
    props: {
        typeCommentPhase: {
            type: Number,
            required: true
        },
        classroomId: {
            type: Number,
            required: true 
        }
    },
    data() {
        return {
            isLoading: false, 
            reviews: null,
            comments: null,
            forecast: {},
            skillList: [
                { key: 'vocabulary', label: 'Vocabulary' },
                { key: 'grammar', label: 'Grammar' },
                { key: 'listening', label: 'Listening' },
                { key: 'speaking', label: 'Speaking' },
                { key: 'reading', label: 'Reading' },
                { key: 'writing', label: 'Writing' }
            ],
            skills: {
                vocabulary: 0,
                grammar: 0,
                listening: 0,
                speaking: 0,
                reading: 0,
                writing: 0
            }
        }
    },
    computed: {
        hasData() {
            return this.reviews && this.comments 
                && Object.keys(this.reviews).length > 0 
                && Object.keys(this.comments).length > 0;
        }
    },
    mounted() {
        this.getReview()
    },
    methods: {
        getReview() {
            this.isLoading = true; 
            this.$store.dispatch(STAGE_REVIEW_DETAIL, {
                classroom_id: this.classroomId,
                user_id: this.$route.params.id,
                sequence: this.typeCommentPhase
            }).then((res) => {
                this.reviews = res?.data?.result || null;
                this.comments = res?.data?.comments || null;
                
                if (this.hasData) {
                    this.handleSkill();
                    this.forecast = this.getForecast(this.comments?.output_achievability);
                }
            }).catch(() => {
                this.$notify({
                    type: 'error',
                    message: 'Lấy nhận xét của giảng viên thất bại',
                    title: 'Thất bại'
                });
            }).finally(() => {
                this.isLoading = false; 
            })
        },
        handleSkill() {
            this.skillList.forEach(({ key }) => {
                const skillData = this.reviews?.metrics?.skills?.[key];
                this.skills[key] = (skillData && skillData.total) 
                    ? Number(((skillData.done ?? 0) * 100 / skillData.total).toFixed(2))
                    : 0;
            });
        },
        getLearningAttitude(att) {
            return ATTITUDE_MAP[att] || '';
        },
        getSupportLabel(type) {
            return SUPPORT_MAP[type] || '';
        },
        getLabelLearningAttitude(type) {
            return ATTITUDE_LABEL_MAP[type] || '';
        },
        getIconLearningAttitude(type) {
            return ATTITUDE_ICON_MAP[type] || '';
        },
        getPlan(type) {
            const plans = {
                'gia_su_bo_tro': 'Gia sư bổ trợ',
                'dieu_chinh_muc_tieu': 'Điều chỉnh mục tiêu'
            };
            return plans[type] || '';
        },
        getForecast(type) {
            return FORECAST_MAP[type] || {};
        }
    }
} 
</script>